import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// API Functions
export const apiService = {
  // Auth
  login: (email, password) => api.post('/auth/login', { email, password }),
  verifyToken: () => api.post('/auth/verify'),
  
  // Hero Slides
  getHeroSlides: () => api.get('/hero-slides'),
  createHeroSlide: (data) => api.post('/hero-slides', data),
  updateHeroSlide: (id, data) => api.put(`/hero-slides/${id}`, data),
  deleteHeroSlide: (id) => api.delete(`/hero-slides/${id}`),
  
  // Services
  getServices: () => api.get('/services'),
  updateService: (id, data) => api.put(`/services/${id}`, data),
  
  // Company Info
  getCompanyInfo: () => api.get('/company-info'),
  updateCompanyInfo: (data) => api.put('/company-info', data),
  
  // News
  getNews: (publishedOnly = true) => api.get(`/news?published_only=${publishedOnly}`),
  createNews: (data) => api.post('/news', data),
  updateNews: (id, data) => api.put(`/news/${id}`, data),
  deleteNews: (id) => api.delete(`/news/${id}`),
  
  // Offices
  getOffices: () => api.get('/offices'),
  createOffice: (data) => api.post('/offices', data),
  updateOffice: (id, data) => api.put(`/offices/${id}`, data),
  deleteOffice: (id) => api.delete(`/offices/${id}`),
  
  // Team
  getTeam: () => api.get('/team'),
  createTeamMember: (data) => api.post('/team', data),
  deleteTeamMember: (id) => api.delete(`/team/${id}`),
  
  // FAQ
  getFAQ: () => api.get('/faq'),
  createFAQ: (data) => api.post('/faq', data),
  deleteFAQ: (id) => api.delete(`/faq/${id}`),
  
  // References
  getReferences: () => api.get('/references'),
  createReference: (data) => api.post('/references', data),
  deleteReference: (id) => api.delete(`/references/${id}`),
  
  // Gallery
  getGallery: () => api.get('/gallery'),
  createGalleryImage: (data) => api.post('/gallery', data),
  deleteGalleryImage: (id) => api.delete(`/gallery/${id}`),
  
  // Quotes
  createQuote: (data) => api.post('/quotes', data),
  getQuotes: () => api.get('/quotes'),
  updateQuoteStatus: (id, status) => api.put(`/quotes/${id}/status`, { status }),
  deleteQuote: (id) => api.delete(`/quotes/${id}`),
  
  // Settings
  getSettings: () => api.get('/settings'),
  updateSettings: (data) => api.put('/settings', data),
};

export default api;